<template>
    <div style="">
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4">
                            <br>
                            <a href="/event/list">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                        </div>
                        <div class="col-4 text-end">
                            <div v-if="is_auth_checked && is_auth" style="display: inline-flex;">
                                <a class="text-center" @click="setPenalty()" style="text-decoration:none;">
                                    <div class="text-center" style="color:#cdcdcd;padding-top:22px;">
                                        <div class="text-nowrap" style="font-size: 14px;">
                                            通報する
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:60px;"></div>
        <div class="wrap">
            <br>
            <div class="row">
                <div class="col px-0 text-center">
                    <img :src="event.img_url + '?' + im" class="img-fluid">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <div style="padding:0 10px;">
                        <div class="row">
                            <div class="col">
                                <h5>{{ event.thumbnail }}</h5>
                                <div style="display:flex">
                                    <div style="padding-right:5px">
                                        <i class="bi bi-clock"
                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                    </div>
                                    <div>
                                        <div v-if="event.event_type == 1">
                                            <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">1部　{{
                                                event.event_at_from_text_1
                                                }}〜{{ event.event_at_to_text_1 }}</div>
                                            <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">2部　{{
                                                event.event_at_from_text_2
                                                }}〜{{ event.event_at_to_text_2 }}</div>
                                        </div>
                                        <div v-if="event.event_type == 2">
                                            <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">1部　{{
                                                event.event_at_from_text_1
                                                }}〜{{ event.event_at_to_text_1 }}</div>
                                            <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">2部　{{
                                                event.event_at_from_text_2
                                                }}〜{{ event.event_at_to_text_2 }}</div>
                                            <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">3部　{{
                                                event.event_at_from_text_3
                                                }}〜{{ event.event_at_to_text_3 }}</div>
                                        </div>
                                        <div v-else>
                                            <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">{{
                                                event.event_at_from_text
                                                }}〜{{ event.event_at_to_text }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display:flex">
                                    <div style="padding-right:5px">
                                        <i class="bi bi-geo-alt"
                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                    </div>
                                    <div>
                                        <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">
                                            {{ event.address_view }}</div>
                                    </div>
                                </div>
                                <div style="display:flex">
                                    <div style="padding-right:5px">
                                        <i class="bi bi-person-fill"
                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                    </div>
                                    <div>
                                        <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">
                                            定員{{ event.member_count }}人</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="member_count != 0">
                        <br />
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="d-grid gap-2" style="padding: 0 5px;">
                                    <a type="button" class="btn btn-luna"
                                        :href="'/event/member/' + this.$route.params['eid']"
                                        style="font-size:18px; padding:12px 0;text-decoration:none;">申込情報の確認</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col px-0">
                            <div style="padding:15px 20px;">
                                <div style="padding-top:10px;padding-left:10px;padding-right:10px;">
                                    <div class="row">
                                        <div class="col px-0">
                                            <div class="d-grid gap-2" style="padding: 2px; ">
                                                <a type="button" class="btn btn-luna" :href="facebook" target="_blank"
                                                    style="border:0;background:#9990FF;border-radius: 4px;">
                                                    <img src="/images/facebook.png" style="width:50px;height:auto;" />
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col px-0">
                                            <div class="d-grid gap-2" style="padding: 2px; ">
                                                <a type="button" class="btn btn-luna" :href="tweet" target="_blank"
                                                    style="border:0;background:#9990FF;border-radius: 4px; height: 36px; overflow: hidden;">
                                                    <TwitterXIcon color="white" width="16" height="16" />
                                                    <span style="color: white; font-size: 9px;">ツイート</span>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col px-0">
                                            <div class="d-grid gap-2" style="padding: 2px; ">
                                                <a type="button" class="btn btn-luna" :href="line" target="_blank"
                                                    style="border:0;background:#9990FF;border-radius: 4px;">
                                                    <img src="/images/line.png" style="width:60px;height:auto;" />
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col px-0">
                                            <div class="d-grid gap-2" style="padding: 2px; ">
                                                <a type="button" class="btn btn-luna" @click="copyToClipboard(copy)"
                                                    style="border:0;background:#9990FF;border-radius: 4px;">
                                                    <img src="/images/copy.png" style="width:50px;height:auto;" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div style="padding:0 10px;">
                        <div class="row">
                            <div class="col"
                                style="padding:5px 35px;white-space: pre-wrap;font-size:14px;font-weight: 600;">{{
                                    event.event_summary }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    イベント詳細
                                </div>
                                <div style="white-space: pre-wrap;font-size:12px;"
                                    v-html="autoLink(event.event_details)">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:8px 20px;">
                                <div style="border-bottom:1px solid #E6E6E6;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    こんな人におすすめ
                                </div>
                                <div style="white-space: pre-wrap;font-size:12px;"
                                    v-html="autoLink(event.event_recommend)">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:8px 20px;">
                                <div style="border-bottom:1px solid #E6E6E6;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    出演者一覧
                                </div>
                                <div class="text-start" style="font-size:12px;">
                                    <div v-for="player in players" :key="player.id">
                                        {{ player.player_name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:8px 20px;">
                                <div style="border-bottom:1px solid #E6E6E6;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    日時
                                </div>
                                <div style="white-space: pre-wrap;font-size:12px;"> {{ event.event_at_from_text }} 〜<br
                                        v-if="isBr()"> {{ event.event_at_to_text }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:8px 20px;">
                                <div style="border-bottom:1px solid #E6E6E6;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    参加費
                                </div>
                                <div style="font-size:12px;" v-if="event.owner_status == 1"
                                    data-testid="official-event-participation-fee">
                                    <div class="row justify-content-center" v-if="event.event_type == 1">
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            1部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount6 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount8 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount5 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount7 | priceLocaleString }}円)</span>
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            2部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount10 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount12 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount9 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount11 | priceLocaleString }}円)</span>
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            通し
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount18 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount20 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount17 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount19 | priceLocaleString }}円)</span>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-else-if="event.event_type == 2">
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            1部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount6 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount8 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount5 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount7 | priceLocaleString }}円)</span>
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            2部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount10 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount12 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount9 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount11 | priceLocaleString }}円)</span>
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            3部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount14 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount16 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount13 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount15 | priceLocaleString }}円)</span>
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            通し
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount18 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount20 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount17 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount19 | priceLocaleString }}円)</span>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-else>
                                        <div class="col" style="padding:10px;">
                                            男性：{{ event.amount2 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount4 | priceLocaleString }}円)</span><br>
                                            女性：{{ event.amount1 | priceLocaleString }}円<span v-if="!isPrepaymentOnly"> ({{
                                                event.amount3 | priceLocaleString }}円)</span>
                                        </div>
                                    </div>
                                </div>
                                <div style="font-size:12px;" v-else>
                                    <div class="row justify-content-center" v-if="event.event_type == 1">
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            1部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount8 | priceLocaleString }}円<br>
                                            女性：{{ event.amount7 | priceLocaleString }}円
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            2部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount12 | priceLocaleString }}円<br>
                                            女性：{{ event.amount11 | priceLocaleString }}円
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            通し
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount20 | priceLocaleString }}円<br>
                                            女性：{{ event.amount19 | priceLocaleString }}円
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-else-if="event.event_type == 2">
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            1部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount8 | priceLocaleString }}円<br>
                                            女性：{{ event.amount7 | priceLocaleString }}円
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            2部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount12 | priceLocaleString }}円<br>
                                            女性：{{ event.amount11 | priceLocaleString }}円
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            3部
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount16 | priceLocaleString }}円<br>
                                            女性：{{ event.amount15 | priceLocaleString }}円
                                        </div>
                                        <div class="col-4 text-center" style="padding-top:20px;">
                                            通し
                                        </div>
                                        <div class="col-8" style="padding:10px;">
                                            男性：{{ event.amount20 | priceLocaleString }}円<br>
                                            女性：{{ event.amount19 | priceLocaleString }}円
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-else>
                                        <div class="col" style="padding:10px;">
                                            男性：{{ event.amount4 | priceLocaleString }}円<br>
                                            女性：{{ event.amount3 | priceLocaleString }}円
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:8px 20px;">
                                <div style="border-bottom:1px solid #E6E6E6;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    会場名
                                </div>
                                <div style="white-space: pre-wrap;font-size:12px;">{{ event.venue_name }}</div>
                                <div style="white-space: pre-wrap;font-size:12px;">{{ event.address }}</div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col text-center" style="padding:10px;">
                                <!-- google_map_tag は管理画面から生HTMLが保存されるため、
                                     XSS防止として iframe src のみ抽出して描画する -->
                                <iframe v-if="googleMapSrc" :src="googleMapSrc" width="100%" height="300"
                                    style="border:0;" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-10" style="padding:8px 20px;">
                                <div style="border-bottom:1px solid #E6E6E6;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding:5px 35px;">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    注意事項
                                </div>
                                <div style="white-space: pre-wrap;font-size:12px;" v-html="autoLink(event.event_notes)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col" style="padding:8px 20px;">
                            <div style="border-bottom:1px solid #E6E6E6;"></div>
                        </div>
                    </div>
                    <div class="row" style="padding:0 20px;">
                        <div class="col" style="">
                            <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                主催
                            </div>
                            <div style="white-space: pre-wrap;font-size:12px;">{{ event.organizer }}</div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
            <br>
            <br>
            <div v-if="is_auth_checked && is_auth" style="margin:0 -12px;background:#E7E7FF;">
                <div style="padding:22px;">
                    <h5>主催者へのお問い合わせ</h5>
                    <div style="color:#6B4EFF;font-size:11px;padding:5px 0;">
                        お名前
                    </div>
                    <input type="text" class="luna-form-control" style="background-color:#fff;border:0"
                        v-model="to_name" placeholder="入力してください" />
                    <div style="color:#6B4EFF;font-size:11px;padding:5px 0;">
                        メールアドレス
                    </div>
                    <input type="email" class="luna-form-control" style="background-color:#fff;border:0"
                        v-model="to_mail" placeholder="入力してください" @input="send_error = ''" />
                    <div style="color:#6B4EFF;font-size:11px;padding:5px 0;">
                        お問い合わせ内容
                    </div>
                    <textarea class="luna-form-control" style="background-color:#fff;border:0" id="to_detail"
                        name="to_detail" rows="5" placeholder="入力してください" v-model="to_detail"></textarea>

                    <div class="row justify-content-center">
                        <div class="col-9">
                            <br />
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-luna disabled" style="padding: 12px 0"
                                    v-if="is_send && to_name.length == 0 && to_mail.length == 0 && to_detail.length == 0">
                                    送信済み
                                </button>
                                <button type="button" class="btn btn-luna disabled" style="padding: 12px 0"
                                    v-else-if="is_load">
                                    <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status"
                                        v-if="is_load">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    送信する
                                </button>
                                <button type="button" class="btn btn-luna" style="padding: 12px 0" id="on-btn"
                                    @click="send()"
                                    v-else-if="to_name.length != 0 && to_mail.length != 0 && to_detail.length != 0">
                                    送信する
                                </button>
                                <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0"
                                    id="non-btn" v-else>
                                    送信する
                                </button>
                            </div>
                            <p class="text-center" style="padding-top:10px;color:#6B4EFF;" v-if="is_send">
                                <small>送信しました</small>
                            </p>
                            <p class="text-center" style="padding-top:10px;color:red;" v-if="send_error">
                                <small>{{ send_error }}</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin:0 -12px;background:#6B4EFF;">
                <Footer></Footer>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <div style="margin:0 -12px;">
            <div class="container-fluid luna-footer-menu" style="background-color:#E7E7FF;">
                <div style="padding:0px 20px;">
                    <div v-if="event_member.is_event == 4">
                        <div class="text-center"
                            style="background:#cdcdcd;border-radius: 10px;padding:20px 0;color:#999">
                            キャンセル済み
                        </div>
                    </div>
                    <div v-else-if="isEventEnd(event.event_at_to)">
                        <div class="text-center"
                            style="background:#cdcdcd;border-radius: 10px;padding:20px 0;color:#999">
                            イベント終了しました。
                        </div>
                    </div>
                    <div v-else-if="member_count != 0">
                        <div class="text-center"
                            style="border-radius: 10px;padding:20px 0;color:#6B4EFF;border:1px solid #C6C4FF;">
                            申込完了しました
                        </div>
                    </div>
                    <div v-else-if="event.is_preparation">
                        <div class="text-center" style="padding:5px 0;color:#6B4EFF;font-size:12px;">
                            {{ event.recruit_at_from_text }} 〜 {{ event.recruit_at_to_text }}まで
                        </div>
                        <div class="text-center"
                            style="border-radius: 10px;padding:10px 0;color:#6B4EFF;border:1px solid #C6C4FF;">
                            受付準備中
                        </div>
                    </div>
                    <div v-else-if="event.is_prepayment_only_registration_closed"
                        data-testid="prepayment-only-registration-closed">
                        <div class="text-center"
                            style="border-radius: 10px;padding:15px 20px;color:#6B4EFF;border:1px solid #C6C4FF;">
                            支払期限を過ぎたため、申し込み受付は終了しました
                        </div>
                    </div>
                    <div v-else-if="event.is_recruiting">
                        <div class="text-center" style="padding:5px 0;color:#6B4EFF;font-size:12px;"
                            v-if="event.owner_status == 1">
                            <span
                                style="padding: 1px 5px;font-size:10px;margin-right:3px;color:#6B4EFF;border:1px solid #6B4EFF;">締切</span>{{
                                    event.recruit_at_to_text }}&nbsp;まで
                        </div>
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <a type="button" class="btn btn-luna" :href="'/event/recruit/' + this.$route.params['eid']"
                                style="border-radius: 10px;padding:12px 0;">
                                <div class="row">
                                    <div class="col-2"></div>
                                    <div class="col text-center">
                                        イベントに申し込む</div>
                                    <div class="col-2 text-end">
                                        <div class="col-2 px-0 text-center">
                                            <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                                <use xlink:href="/images/>.svg#page_right"></use>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div v-else>
                        <div class="text-center"
                            style="border-radius: 10px;padding:15px 20px;color:#6B4EFF;border:1px solid #C6C4FF;">
                            申込上限に達しました
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TwitterXIcon from '../components/Icon/TwitterXIcon.vue';
import Footer from './../Footer.vue'
import { isPrepaymentOnlyEvent } from './paymentOptions';
export default {
    data() {
        return {
            event: [],
            event_member: { is_event: 9 },
            players: [],
            member_count: 0,
            is_advertisements: false,
            advertisements: [],
            ad_index_1: 0,
            ad_index_2: 1,
            tweet: '',
            facebook: '',
            line: '',
            copy: '',
            is_load: false,
            to_name: "",
            to_mail: "",
            to_detail: "",
            is_send: false,
            send_error: "",
            is_auth: false,
            is_auth_checked: false,

            im: '',
        };
    },
    computed: {
        isPrepaymentOnly() {
            return isPrepaymentOnlyEvent(this.event);
        },
        // google_map_tag から iframe の src 属性だけを抽出する。
        // Google Maps 埋め込みURL以外は無視し、任意HTML実行（XSS）を防止する。
        // 管理画面からの入力しかできないので最小限
        googleMapSrc() {
            if (!this.event || !this.event.google_map_tag) {
                return null
            }
            const match = this.event.google_map_tag.match(/src=["']([^"']+)["']/)
            if (!match) {
                return null
            }
            const src = match[1]
            // Google Maps の埋め込みURLのみ許可
            if (src.startsWith('https://www.google.com/maps/embed')) {
                return src
            }
            return null
        },
    },
    methods: {
        async send() {
            this.is_load = true
            this.send_error = ""
            await axios
                .post("/api/event/send", {
                    event_id: this.event['id'],
                    name: this.to_name,
                    mail: this.to_mail,
                    detail: this.to_detail,
                })
                .then((response) => {
                    this.is_send = true
                    this.is_load = false

                    this.to_name = ""
                    this.to_mail = ""
                    this.to_detail = ""

                    setTimeout(() => {
                        this.is_send = false
                    }
                        , 3000
                    )
                })
                .catch((error) => {
                    this.is_load = false
                    const status = error.response ? error.response.status : null
                    if (status === 422) {
                        this.send_error = "メールアドレスを正しく入力してください"
                    } else if (status === 409) {
                        this.send_error = "このイベントには現在お問い合わせできません"
                    } else {
                        this.send_error = "送信に失敗しました。時間をおいて再度お試しください"
                    }
                })
        },
        async getAdvertisements() {
            axios.get("/api/advertisement/get/5")
                .then((response) => {
                    this.advertisements = response.data.advertisements
                    this.is_advertisements = this.advertisements.length > 0

                    if (response.data.advertisements.length <= 1) {
                        this.ad_index_2 = 0
                    }
                })
        },
        async fetchEvent() {
            let response = await axios.get("/api/event/show/" + this.$route.params['eid'])
                .then((response) => {
                    this.event = response.data.event;
                    this.players = response.data.players;
                    this.member_count = response.data.member_count;
                    this.tweet = response.data.tweet;
                    this.facebook = response.data.facebook;
                    this.line = response.data.line;
                    this.copy = response.data.copy;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                })

            try {
                let response_auth = await axios.get("/api/user/is_auth");
                this.is_auth = response_auth.data.is_atuh;
            } catch (error) {
                this.is_auth = false;
            }
            this.is_auth_checked = true;

            if (this.is_auth) {
                await axios
                    .get("/api/event/member/" + this.$route.params["eid"])
                    .then((response) => {
                        if (response.data.event_member != null) {
                            this.event_member = response.data.event_member;
                        }
                    })
                    .catch((error) => {

                        if (error.response && error.response.status == 401) {
                            //window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("イベント参加者の取得に失敗しました")
                        }
                    })
            }
        },
        isBr() {
            if (this.event.event_at_to_text == undefined) {
                return false
            }

            if (this.event.event_at_to_text.length > 5) {
                return true
            }
            else {
                return false
            }
        },
        isEventEnd(event) {
            if (event == undefined) {
                return false
            }

            console.log(event)
            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            return (eDate < today);
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    alert('コピーしました。')
                })
        },
        async setPenalty() {
            await axios.get("/api/event/penalty/" + this.$route.params['eid'])
                .then((response) => {
                    alert("通報しました。");
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通報に失敗しました")
                    }
                })
        },
        escapeHtml(str) {
            // v-html で描画するため、危険文字は必ずエスケープする
            return str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;')
        },
        autoLink(value) {
            if (value != undefined) {
                const text = String(value)
                // URL終端に使われることが多い記号（<, >, ", '）はURLに含めない
                const urlRegex = /https?:\/\/[^\s<>"']+/g
                let result = ''
                let lastIndex = 0
                let match

                while ((match = urlRegex.exec(text)) !== null) {
                    const url = match[0]
                    const offset = match.index

                    // URL以外の区間はエスケープしてそのまま出力
                    result += this.escapeHtml(text.slice(lastIndex, offset))
                    const escapedUrl = this.escapeHtml(url)
                    // URL区間だけ安全にリンク化
                    result += "<a rel='noopener noreferrer' href='" + escapedUrl + "' target='_blank'>" + escapedUrl + "</a>"

                    lastIndex = offset + url.length
                }

                result += this.escapeHtml(text.slice(lastIndex))
                return result
            }
            else {
                return value
            }
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.im = Date.now()
                            //this.getAdvertisements()
                            this.fetchEvent()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.im = Date.now()
                //this.getAdvertisements()
                this.fetchEvent()
            }
        }
        else {
            this.im = Date.now()
            //this.getAdvertisements()
            this.fetchEvent()
        }
    },
    components: {
        Footer: Footer,
    },
    filters: {
        priceLocaleString(value) {
            if (value != undefined) {
                return value.toLocaleString()
            }
            else {
                return value
            }
        },
    },
}
</script>
<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.luna-item-bar {
    background: #6B4EFF;
    color: #fff;
}

.subtitle {
    padding: 10px;
    font-size: 20px;
    border-bottom: 2px solid #6B4EFF;
}
</style>
